import { handleError } from '@anchorage/sentry';
import type { IconName } from '@latitude/icons';

export const GroupIcon = (icon: string): IconName => {
  switch (icon) {
    case 'person':
    case 'INDIVIDUAL':
      return 'user';
    case 'RELATED_PARTY':
    case 'RELATED_PARTY_INSTITUTION':
      return 'building';
    case 'TAX_CERTIFICATION':
      return 'certificate';
    default:
      handleError(new Error(`Case ${icon} not found for GroupIcon`));
      return 'user';
  }
};
